import { Component, inject, computed } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';

import { Sidebar as SidebarService } from '@shared/services';
import { Auth } from '@core/services';
import { UserRole } from '@core/interfaces/role.interface';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.scss'
})
export class Sidebar {
  private router = inject(Router);
  private authService = inject(Auth);
  sidebarService = inject(SidebarService);

  user = computed(() => this.authService.user || {});
  isAdmin = computed(() => this.user().role?.name === UserRole.ADMIN);
  isReseller = computed(() => this.user().role?.name === UserRole.RESELLER);

  logout() {
    this.authService.user = null;
    this.authService.token = '';
    localStorage.clear();
    this.router.navigate(['/login']);
  }
}
